// Port of api/fuel/app/classes/insights/ratings/publishers.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'publishers',
    priority: 1,
    default_: true,
    requires: [],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_ratings()) return {}

        var self = this

        var limit = detail ? 100 : 5
        var threshold = (owner.get_threshold() * 2) + 1

        var ranked = []

        var filterType = (filter.publishers !== undefined) ? filter.publishers : 'best'

        // Hot SQL: rating × game join, then a 26k-row game_publisher join.
        // queryFast for both, plain ints for game ids in the inner loop.
        var ratingRows = Util.queryFast('\
            SELECT \
                r.game_id AS game, \
                AVG(r.rating_value) AS rating, \
                COUNT(r.rating_id) AS ratings \
            FROM \
                rating r \
                JOIN \
                game g \
            WHERE \
                r.game_id = g.game_id \
                AND \
                g.game_type = 1 \
                AND \
                r.user_id IN (' + Util.in(userIndex) + ') \
            GROUP BY \
                g.game_id \
        ')
        var ratings = {}
        var ratingIndex = []
        for (var ri = 0; ri < ratingRows.length; ri++) {
            var rr = ratingRows[ri]
            ratings[rr.game] = rr
            ratingIndex.push(rr.game)
        }

        if (ratingIndex.length) {

            var applicable = Util.queryFast('\
                SELECT \
                    l.game_id AS game, \
                    l.publisher_id AS publisher \
                FROM \
                    game_publisher l \
                WHERE \
                    l.game_id IN (' + Util.in(ratingIndex) + ') \
                    AND \
                    l.publisher_id <> 1001 \
                    AND \
                    l.publisher_id <> 4 \
                    AND \
                    l.game_publisher_primary = 1 \
                    AND \
                    l.game_version_id = 0 \
            ')

            var grouped = {}

            for (var i = 0; i < applicable.length; i++) {
                var link = applicable[i]
                var pubKey = link.publisher
                var game_id = link.game
                var ratingRow = ratings[game_id]
                if (!ratingRow) continue

                var entry = grouped[pubKey]
                if (!entry) {
                    entry = grouped[pubKey] = {
                        publisher: pubKey | 0,
                        games: [],
                        rating: 0,
                        ratings: 0,
                        average: 0
                    }
                }

                var rrCount = ratingRow.ratings | 0
                entry.games.push(game_id | 0)
                entry.ratings += rrCount
                entry.rating += rrCount * ratingRow.rating
                entry.average = entry.rating / entry.ratings
            }

            // filter by threshold
            var filteredGroups = {}
            var gkeys = Object.keys(grouped)
            for (var fi = 0; fi < gkeys.length; fi++) {
                if (grouped[gkeys[fi]].ratings >= threshold) {
                    filteredGroups[gkeys[fi]] = grouped[gkeys[fi]]
                }
            }

            var filteredArray = Object.keys(filteredGroups).map(function(k) { return filteredGroups[k] })

            if (filteredArray.length) {

                var sorted = filteredArray.slice().sort(function(a, b) {
                    if (filterType === 'best') {
                        if (a.average !== b.average) return b.average - a.average
                        if (a.ratings !== b.ratings) return b.ratings - a.ratings
                    } else {
                        if (a.ratings !== b.ratings) return b.ratings - a.ratings
                        if (a.average !== b.average) return b.average - a.average
                    }
                    return a.publisher - b.publisher
                })

                sorted = sorted.slice(0, limit)

                var publisherIds = Util.pluck(sorted, 'publisher')
                // Raw query for publisher names instead of Publisher.where().associated()
                // (which instantiates a Publisher Model per row).
                var detailRows = Util.queryFast(
                    'SELECT publisher_id, publisher_name FROM publisher WHERE publisher_id IN(' + Util.in(publisherIds) + ')'
                )
                var details = {}
                for (var dr = 0; dr < detailRows.length; dr++) {
                    details[detailRows[dr].publisher_id] = detailRows[dr]
                }

                for (var si = 0; si < sorted.length; si++) {
                    var item = sorted[si]

                    var gameRatings = []

                    for (var gi = 0; gi < item.games.length; gi++) {
                        var gid = item.games[gi]
                        gameRatings.push({
                            id: gid,
                            rating: (ratings[gid] && ratings[gid].rating !== undefined) ? parseFloat(ratings[gid].rating) : '-'
                        })
                    }

                    gameRatings = gameRatings.sort(function(a, b) {
                        if (a.rating !== b.rating) return b.rating - a.rating
                        return a.id - b.id
                    })

                    for (var rri = 0; rri < 3 && rri < gameRatings.length; rri++) {
                        self._references.games.push(gameRatings[rri].id)
                    }

                    var detail = details[item.publisher]
                    ranked.push({
                        id: detail ? (detail.publisher_id | 0) : item.publisher,
                        name: detail ? (detail.publisher_name || '') : '',
                        count: item.ratings,
                        rating: Math.round(item.average * 10) / 10,
                        games: gameRatings.slice(0, 3),
                        gamesCount: item.games.length
                    })
                }

            }

        }

        return {
            publishers: ranked
        }

    }
})
